// MUI components
import { ColumnData } from "assets/types/ColumnData";

const columns: ColumnData[] = [
	{
		headerName: "Order Id",
		field: "userId",
		renderCell: ({ row }) => <>{row.orderId}</>,
	},
	{
		headerName: "User Name",
		field: "userName",
		renderCell: ({ row }) => <>{row.name}</>,
	},
	{
		headerName: "Order Date",
		field: "orderDate",
		renderCell: ({ row }) => <>{row.orderDate}</>,
	},
	{
		headerName: "Payment",
		field: "payment",
		renderCell: ({ row }) => <>{row.payment}</>,
	},
	{
		headerName: "Quantity",
		field: "quantity",
		renderCell: ({ row }) => <>{row.quantity}</>,
	},
	{
		headerName: "Amount",
		field: "amount",
		renderCell: ({ row }) => <>{row.amount}</>,
	},
	{
		headerName: "Status",
		field: "status",
		renderCell: ({ row }) => <>{row.status}</>,
	},
];

const dataTableData = {
	columns,
};

export default dataTableData;
